// Replace placeholders: drop real logo files into /public/clients/ and update this array.
// Each entry can have either { name, logo } (real image) or { name, placeholder: true } (chip).

export const clients = [
  { name: "Client One", placeholder: true },
  { name: "Client Two", placeholder: true },
  { name: "Client Three", placeholder: true },
  { name: "Client Four", placeholder: true },
  { name: "Client Five", placeholder: true },
  { name: "Client Six", placeholder: true },
];
